import styled , { keyframes } from 'styled-components';
import { WhiteContainer } from '../../theme/theme';
import MainButton from '../MainButton';
import { TextField } from '@material-ui/core';


const fontFamily = 'Raleway'

const slideUp = keyframes`
    from {
        transform: translate(0, 100vh);
    }
    to {
        transform: translate(0, 1vh);
        visibility: visible;
    }
`

const slideDown = keyframes`
     from {
        transform: translate(0, 1vh);
    }
    to {
        transform: translate(0, 100vh);
        visibility: visible;
        opacity: 1;
    }
`

const CartTotalSummaryContainer = styled.section`
    margin: .5em 0em 0em 0em;
    background: none;
    flex: 1 1 auto;
    box-sizing: border-box;
    position: relative;
    max-width: 35%;
    width: 35%;
    margin-top: 1rem;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        max-width: 100%;
        position: absolute;
        box-sizing: border-box;
        bottom: 0px;
        height: 3.5rem;
        margin: 0;
        width: 100%;
        background-color: transparent;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        display: flex;
        z-index: 100;
    }

`
const CartTotalSummaryBody = styled(WhiteContainer)<any>`
    border-radius: 4px;
    position: ${props => props.position ? props.position : 'sticky'};
    height: auto;
    margin: auto;
    top: 5px;
    margin: 0;
    flex: 1;
    padding: 2vh 2vh;
    box-sizing: border-box;
    box-shadow: none;
    background: #F5F5F5;
    margin-top: 1rem;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        padding: 0;
        flex: 1;
        background-color: transparent;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
`
const CartTotalSummaryDetail = styled.div`
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    & * {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0.7vh 0.5vh;
        font-size: 0.9rem;
        font-weight: 500;
        @media (max-width: ${props => props.theme.breakpoints.md}) {
            margin: 0.5vh 0.5vh;
        }

    cart-total-summary__title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    
    .cart-total-summary__title {
        font-weight: 400;
        font-size: 16px !important;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        padding: 1vh;

        .cart-total-summary__title-detail {
            text-align: end;
        }
    }
}
`

type CartSummaryModalMobileProps = {
    show: boolean
}

const CartSummaryModalMobile = styled.section<CartSummaryModalMobileProps>`
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: ${props => props.show ? 'block' : 'none'};
    position: fixed !important;
    top: 66px;
    left: 0;
    right: 0;
    bottom: 50px;
    z-index: 1000;
    width: 100%;
    box-sizing: border-box;
    padding: 9px;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    background-color: #F3F3F4;
  }
`

const CartTotalSummaryTitleContainer = styled.div`
    @media (min-width: ${props => props.theme.breakpoints.md}) {
    & :nth-child(2)  {
                // display: none;
            }

        margin-bottom: 2rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        text-align: left;
        padding: 0 2vh;
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: space-between;
    }
`
const CartTotalSummaryTitle = styled.h3<any>`
    font-family: ${fontFamily};
    font-weight: 600;
    text-align: center;
    font-size: 1.2rem;
    margin-top: ${props => props.mp ? props.mp : '0px'};
`

const CartTotalSummaryAmount = styled.div`
    background-color: #FFFFFF;
    border-radius: 8px;
    margin: 2vh 0;
    padding: 0 1vh;
    height: 3em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    & :nth-child(2){
            color: red;
            @media (max-width: ${props => props.theme.breakpoints.md}) {
                color: black;
                font-weight: 900;
            }
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        background: #FFFFFF;
        padding: 0;
        font-weight: 900;
        margin: 0.5vh 0.5vh;
        padding: 0vh 2.5vh;

        & :first-child {
            :after {
                /* content: ':';
                margin-right: 15px; */
            }
        }
    }
`
const CheckoutContainer = styled.form`
    display: flex;
    flex-direction: column;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 100%;
        background-color: #F3F3F4;
        border-top: 1px solid #C4C4C4;
        box-sizing: border-box;
    }
`

const CartPaymentButton = styled(MainButton)`
    width: 100%;
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        display: flex;
        display: inline-block;
        font-weight: 400;
        padding: 0.4rem;
        font-size: 0.9em;
        border-radius: 5px;
        text-align: center;
        width: 30vw;
    }
`

type ExpandCardButtonProps = {
    toggled: boolean
}

const ExpandCardButton = styled.span<ExpandCardButtonProps>`

    @media (min-width: ${props => props.theme.breakpoints.md}) {
        display: none
    }
    
    box-sizing: border-box;
    height: 2.5vw;
    width: 2.5vw;
    margin-left: 1.5vw;
    border-style: solid;
    border-color: black;
    border-width: 0px 1px 1px 0px;
    transform: rotate( ${props => props.toggled ? '45deg': '225deg'} );
    transition: border-width 150ms ease-in-out;
`

type OnlyMobileComponentProps = {
    showOnlyOnMobile?: boolean
    language: string
}

const AddMoreProducts = styled.a.attrs({ target:"_blank", rel:"noopener noreferrer"})<OnlyMobileComponentProps>`
    display: ${props => props.showOnlyOnMobile? 'none' : 'block'};  
    text-decoration: underline;
    font-weight: bold;
    font-size: 0.8em;
    text-align: center;
    margin-top: 10px;
    margin-right: auto;
    margin-left: auto;
    &:visited {
        color: black;
    }
    &:after{
        content: ${props => props.language};
        cursor: pointer;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}) {
        display: ${props => props.showOnlyOnMobile ? 'block' : 'none'};
        margin-bottom: 30px;
    }
`
const TermsAndConditionsContainer = styled.div`
    display: flex;  
    flex-direction: column;
    margin: 0px 5px 10px 5px;
    margin-bottom: 10px;
    padding: 1px;
    box-sizing: border-box;
    & div {
        padding: 1px;
        display: flex;
    }

`

const TermsAndConditionsLabel = styled.label`
    font-size: 0.65em;
    padding: 0;
    line-height: 1.6;
`

const AnchorLink = styled.a.attrs({ target:"_blank", rel:"noopener noreferrer" })`
    font-weight: bold;
`

const ContainerOneStep = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 350px;

        @media (max-width: ${props => props.theme.breakpoints.md}) {
        &.is-on-step-one {
            display: none !important;
        }
    }
`

const ContainerTwoStep = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 350px;

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        min-height: 0;
        justify-content: flex-start;

        & ${CartTotalSummaryTitleContainer} {
            flex: none;
        }
    }
`

const DiscountCodeInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 1rem;
`

const CartDetailSummaryContainer = styled.div`
    display: flex;
    flex-direction: column;

    margin-top: 6rem;
    border-top: 1px solid #B1B8D0;

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        margin-top: 2rem;
    }

`

const DiscountCodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0vh 2.5vh;
    
`

const DiscountCodeInputField = styled(TextField) <any>`
  flex: 1;
  padding: 5px;
  border: 0.68px solid #5C5B5C;
  border-radius: 4px;   
  background: #FFFFFF;

  .MuiInputBase-input {
    padding: 6px 6px 7px;
    border: 0.68px solid #5C5B5C;
    border-color: #5C5B5C;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    ${props => props.error? 'color: #E1251B;' : ''}
  }

  .MuiInput-underline:after {
    transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before{
    border-bottom: 1px solid #5C5B5C;
  }
  .MuiInput-underline:after, .MuiInput-underline:before{
    border: none !important;
  }
`


const DiscountCouponsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;

    .discount_labels{
        display: flex;
        gap: 1rem;
        flex-direction: row;
        flex-wrap: wrap;
    }
`

const DiscountCodeLabelContainer = styled.div`
    width: fit-content;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    padding: 3.94787px 4.3518px 3.17588px 4.5798px;
    gap: 4.72px;

    background: #FFFFFF;

    /* border: 0.771985px solid #213473; */
    border: 0.771985px solid ${(props) => props.color};

    border-radius: 3.85993px;

    &.error {
        border: 0.771985px solid #E1251B;
    }

    .discount-code__label-icon, .MuiSvgIcon-root{
        font-size: 1em;
        color: ${(props) => props.color};

        transform: rotate(-135deg);

        &.error {
        color: #E1251B;
        }
    }

    .discount-code__name {
        font-style: normal;
        font-weight: 600;
        font-size:  12.26382px;
        line-height: 15px;
        color: ${(props) => props.color};
        text-transform: capitalize;

        &.error {
        color: #E1251B;
        }
    }

    .discount-code__discount-amount {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size:  12.26382px;
        line-height: 15px;
        color: ${(props) => props.color};

        &.error {
        color: #E1251B;
        }
    }
`

const DiscountCodeButton = styled.button`
    background: #FFFFFF;
    color: ${(props) => props.color};

    border: none;
    font-weight: 800;
    font-size:  14.26px;

    cursor: pointer;

    &.error {
        color: #E1251B;
        }

    &:hover { 
        color: #FFFFFF;
        background: ${(props) => props.color};
        border-radius: 25%;
        transition: all 0.2s ease-in-out;

        &.error {
            background: #E1251B;
        }

    }

`

const DiscountCodeErrorText = styled.div`
    color: #E1251B;

    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;

    margin-top: 0.5rem;
    margin-bottom: 1rem;
`
const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;

export {
    ContainerOneStep,
    ContainerTwoStep,
    AnchorLink,
    AddMoreProducts,
    CartTotalSummaryContainer, 
    CartTotalSummaryAmount, 
    CartSummaryModalMobile,
    CheckoutContainer,
    CartTotalSummaryTitle, 
    CartTotalSummaryTitleContainer,
    CartPaymentButton,
    CartTotalSummaryBody, 
    CartTotalSummaryDetail,
    CartDetailSummaryContainer,
    ExpandCardButton,
    TermsAndConditionsContainer,
    TermsAndConditionsLabel,
    DiscountCodeInputContainer,
    DiscountCodeInputField,
    DiscountCodeContainer,
    DiscountCodeLabelContainer,
    DiscountCodeButton,
    DiscountCodeErrorText,
    DiscountCouponsContainer,
    LoadContainer
}